import { render } from "./TripForm.vue?vue&type=template&id=68cc5b09&scoped=true"
import script from "./TripForm.vue?vue&type=script&lang=js"
export * from "./TripForm.vue?vue&type=script&lang=js"

import "./TripForm.vue?vue&type=style&index=0&id=68cc5b09&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68cc5b09"]])

export default __exports__